import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { getFeaturesForUser } from "../services/UserAuthorization";
import { extractFeaturesFromRoles } from "../utils/extractFeaturesList";

const FeatureContext = createContext(null);

export const FeatureProvider = ({ children }) => {
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadFeatures = useCallback(async (userName) => {
        if (!userName) return;

        setLoading(true);
        try {
            const res = await getFeaturesForUser({ userName });
            const roles = res?.roles || [];
            setFeatures(extractFeaturesFromRoles(roles));
        } catch (err) {
            console.error("Failed to load features", err);
            setFeatures([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const contextValue = useMemo(
        () => ({
            features,
            loading,
            loadFeatures,
        }),
        [features, loading, loadFeatures]
    );

    return (
        <FeatureContext.Provider value={contextValue}>
            {children}
        </FeatureContext.Provider>
    );
};

export const useFeatures = () => {
    const ctx = useContext(FeatureContext);
    if (!ctx) {
        throw new Error("useFeatures must be used inside FeatureProvider");
    }
    return ctx;
};